import styled from "styled-components"
import {StepIndicator} from "./"

const NarrowStepIndicator = styled(StepIndicator)`
  width: 200px;
`

export default NarrowStepIndicator
